import {Attributes, DataStatus} from 'platform/components';
import {Box} from 'platform/foundation';

import {isNil} from 'ramda';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {useGetVehicleInformation} from '../../../../../hooks/useGetVehicleInformation';

interface RentalVehicleTooltipProps extends RequiredTestIdProps {
  vehicleId: string | Nullish;
}

export function RentalVehicleTooltip(props: RentalVehicleTooltipProps) {
  const [vehicleRows, areVehicleInformationLoading] = useGetVehicleInformation(props.vehicleId);

  if (isNil(props.vehicleId)) {
    return null;
  }

  return (
    <Box padding={4}>
      <Box
        backgroundColor="palettes.white.10.100"
        borderRadius="medium"
        padding={4}
        boxShadow="elevation_4"
        minWidth={120}
        width="100%"
        border="1px solid"
        borderColor="palettes.neutral.40.100"
        data-testid={suffixTestId('rentalVehicleTooltip', props)}
      >
        <DataStatus isLoading={areVehicleInformationLoading} minHeight={120}>
          <Attributes
            data-testid={suffixTestId('rentalVehicleTooltip', props)}
            rows={vehicleRows}
            size="third"
          />
        </DataStatus>
      </Box>
    </Box>
  );
}
